'use client';

import { useEffect } from 'react';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    console.error('[Root Layout Global Error]', error);
  }, [error]);

  return (
    <html lang="id">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Terjadi Kesalahan | Jogjalib</title>
      </head>
      <body className="flex min-h-screen items-center justify-center bg-background p-4 font-sans text-foreground">
        <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-lg">
          <div className="mb-4 text-6xl">🔧</div>
          <h1 className="mb-2 text-2xl font-bold text-foreground">
            Terjadi Masalah Sistem
          </h1>
          <p className="mb-6 text-sm text-muted-foreground">
            Aplikasi mengalami kesalahan tak terduga. Silakan muat ulang
            halaman.
          </p>
          <button
            type="button"
            onClick={reset}
            className="w-full rounded-xl bg-primary-600 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-700 active:scale-95"
          >
            Muat Ulang Aplikasi
          </button>
        </div>
      </body>
    </html>
  );
}
